import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgLongTermGoal = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M11 3a5 5 0 1 1-3 8.999A5 5 0 1 1 8 4c.836-.628 1.874-1 3-1M5 4.5a3.5 3.5 0 1 0 1.938 6.414A4.98 4.98 0 0 1 6 8c0-1.088.348-2.094.938-2.915A3.5 3.5 0 0 0 5 4.5m6 0c-.717 0-1.384.215-1.938.585.59.82.938 1.827.938 2.915a4.98 4.98 0 0 1-.938 2.914A3.5 3.5 0 1 0 11 4.5"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLongTermGoal);
export default ForwardRef;
